import { FC } from "react";

const View24: FC = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3333 7C9 7 6.15333 9.07333 5 12C6.15333 14.9267 9 17 12.3333 17C15.6667 17 18.5133 14.9267 19.6667 12C18.5133 9.07333 15.6667 7 12.3333 7ZM12.3333 15.3333C10.4933 15.3333 9 13.84 9 12C9 10.16 10.4933 8.66667 12.3333 8.66667C14.1733 8.66667 15.6667 10.16 15.6667 12C15.6667 13.84 14.1733 15.3333 12.3333 15.3333ZM12.3333 10C11.2267 10 10.3333 10.8933 10.3333 12C10.3333 13.1067 11.2267 14 12.3333 14C13.44 14 14.3333 13.1067 14.3333 12C14.3333 10.8933 13.44 10 12.3333 10Z"
          fill="black"
        />
      </svg>
    </>
  );
};

export default View24;
